import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview'
import {
    LayoutFilter,
    BackgroundFilter,
    LinkFilter,
    ItemBackgroundFilter,
    ReviewItemFrameFilter,
    OuterWrapperFrameFilter,
    MinimalRatingFilter
} from '../components/filters'
import { __ } from '../../locales'

class WfCarousel extends Component {
    state = {
        selectedLayout: 'layoutA',
        layoutOptions: [
            {
                label: 'Carousel Layout A',
                value: 'layoutA'
            },
        ]
    };

    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.review_box_carousel.name')}
                description={__('widget.review_box_carousel.description')}
                bestFor={[__('global.homepage'), __('global.footer')]}
                type={'carousel-widget'}
                extraParams={[
                    'slugs',
                    'background',
                    'itemBackground',
                    'outerFrame',
                    'itemFrame',
                    'rating',
                    'linkUrl',
                ]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.carousel')}
                badgeColor={'#2B59E0'}
                badgeFontColor={'#FFFFFF'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <LinkFilter
                        {...props}
                        hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
                    />
                    <LayoutFilter
                        selectedLayout={state.selectedLayout}
                        options={state.layoutOptions}
                        onChange={ev => this.setState({ selectedLayout: ev.target.value })}
                    />
                    <BackgroundFilter {...props} />
                    <ItemBackgroundFilter {...props} />
                    <MinimalRatingFilter {...props} />
                    <ReviewItemFrameFilter {...props} />
                    <OuterWrapperFrameFilter {...props} />
                </div>
            </WidgetPreview>
        );
    }
}

export default WfCarousel
